import SAPOMailConfig     from "@/SAPOMailConfig";
import HTTPResponseEntity from '@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity.js';
import HTTPService        from "@/js/Shared/Services/HTTP/HTTPService.js";
import FiltersItem        from "../Entities/FiltersItem";

export {FiltersHTTPService as default };

/**
* Imap Security HTTP Service
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FiltersHTTPService {
  /**
   * Filters Endpoint
   *
   * @public
   *
   * @type {Object}
   *
   * @since 7.0.0
   */
  endpoint = SAPOMailConfig.client.endpoints.settings.filters;

  /**
   * Fetches filters list from the backend server
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async fetchList() {
    return await HTTPService.post(this.endpoint + '/list');
  }

  /**
   * Fetches filters list from the backend server
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FiltersItem} filter filter entity
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async enableFilter(filter) {
    return await HTTPService.post(this.endpoint + '/enable' , {uid : filter.id});
  }

  /**
   * Fetches filters list from the backend server
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FiltersItem} filter filter entity
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async disableFilter(filter) {
    return await HTTPService.post(this.endpoint + '/disable',  {uid : filter.id});
  }

  /**
   * Calls the api to save filter
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FiltersItem} filter filter entity
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async saveFilter(filter) {
    let request = {};
    Object.assign(request, filter);
    request.flags      = this.mapRequestFlags(filter);
    request.conditions = JSON.stringify(request.conditions);

    if (!filter.id) {
      request.enabled = true;
    }



    if (filter.id) {
      request.edit = filter.id;
    }

    if (filter.action !== "Ingo_Rule_User_Move") {
      request.action_value = '';
    }

    return await HTTPService.post(this.endpoint + '/save',  request);
  }

  /**
   * Map only flags that are checked
   *
   * @return {Array}
  */
  mapRequestFlags(filter){
    let flags = [];

    if(filter.action !== "Ingo_Rule_User_Discard"){
      for (const flag in filter.flags) {
        const flag_status = filter.flags[flag];

        if(flag_status){
          flags.push(flag);
        }
      }
    }

    return flags;
  }

  /**
   * Calls the api to save filter
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FiltersItem} filter filter entity
   *
   * @return {Promise.<HTTPResponseEntity>}
   */
  async deleteFilter(filter) {
    let request = {
      uid : filter.id,
    };

    return await HTTPService.post(this.endpoint + '/delete',  request);
  }
}